var preSearchRegexp = /.*\?(.+)/;
export default (function (url) {
	var match = url.match(preSearchRegexp);
	return match ? '?' + match[1] : '';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@livechat/url-utils/es/getSearch.js
// module id = 533
// module chunks = 0